exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".answer-debug-wrapper[data-v-46f74062] {\n  order: 3;\n  flex-basis: 100%;\n}\n.answer-debug[data-v-46f74062] {\n  background-color: #fff59d;\n}\ntable[data-v-46f74062] {\n  width: 100%;\n  font-size: 0.6em;\n  border-collapse: collapse;\n}\ntable[data-v-46f74062], th[data-v-46f74062], td[data-v-46f74062] {\n  border: 1px solid black;\n  text-align: center;\n}\ntd[data-v-46f74062] {\n  background-color: #fffad0;\n}", ""]);

// exports
